module.exports = __webpack_public_path__ + "img/baguanxuewei.c6e055a9.png";